import { shallowEqual } from "react-redux";
import { selectors } from "../../../features/benefitChoice/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
function useGetVehicleBenefitsChoice(vehicleItem) {
  const benefitsChoice = useAppSelector((state) => {
    const { id: vehicleId, data } = vehicleItem || {};
    const { benefits, maxBenefit } = data || {};
    if (!vehicleId || !benefits) {
      return [];
    }
    const benefitsChoice2 = selectors.selectById(state.benefitChoice, vehicleId);
    if (benefitsChoice2) {
      return benefitsChoice2.benefits;
    }
    if (!maxBenefit) {
      return [];
    }
    return benefits.filter((benefit) => maxBenefit.some((maxBenefit2) => maxBenefit2.id === benefit.id));
  }, shallowEqual);
  return benefitsChoice;
}
export {
  useGetVehicleBenefitsChoice
};
